import Vue from 'vue'
import Router from 'vue-router'
import { vuexOidcCreateRouterMiddleware } from 'vuex-oidc'

import store from './store';
import OidcCallback from './components/OidcCallback.vue'
import Home from './views/Home.vue'
import Alerts from './views/Alerts.vue'
import Alert from './views/Alert.vue'
import Notification from './views/Notification.vue'
import Investigate from './views/Investigate.vue'
import Investigations from './views/Investigations.vue'
import Misnomer from './views/Misnomer.vue'
import Misnomers from './views/Misnomers.vue'
import Contacts from './views/Contacts.vue'
import Support from './views/Support.vue'
import StatsCounty from './views/StatsCounty.vue'
import StatsByRule from './views/StatsByRule.vue'
import SupportMonthComparison from './views/SupportMonthComparison.vue'
import ExtractStatus from './views/ExtractStatus.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      component: OidcCallback,
      path: '/signin-oidc',
      name: 'oidc-callback',
      meta: {
        isVuexOidcCallback: true,
        isPublic: true,
      },
    },
    {
      component: Home,
      path: '/',
      name: 'home',
    },
    {
      path: '/alerts',
      name: 'alerts',
      component: Alerts,
    },
    {
      path: '/extract-status',
      name: 'extract-status',
      component: ExtractStatus,
    },
    {
      component: Alert,
      path: '/alerts/:alert_category',
      name: 'alert',
    },
    {
      component: Notification,
      path: '/alerts/:alert_category/:reference',
      name: 'notification',
    },
    {
      component: Investigate,
      path: '/alerts/:alert_category/:reference/investigate',
      name: 'investigate',
    },
    {
      component: Misnomer,
      path: '/alerts/:alert_category/:reference/misnomer',
      name: 'misnomer',
    },
    {
      component: Investigations,
      path: '/investigations',
      name: 'investigations',
    },
    {
      component: Misnomers,
      path: '/misnomers',
      name: 'misnomers',
    },
    {
      component: Contacts,
      path: '/contacts',
      name: 'contacts',
    },
    {
      component: Support,
      path: '/support',
      name: 'support',
    },
    {
      component: StatsCounty,
      path: '/stats-county',
      name: 'stats-county',
    },
    {
      component: SupportMonthComparison,
      path: '/support-month-comparison',
      name: 'support-month-comparison',
    },
    {
      component: StatsByRule,
      path: '/stats-by-rule',
      name: 'stats-by-rule',
    }
  ],
})

// require auth for pages that aren't flagged as public
router.beforeEach(vuexOidcCreateRouterMiddleware(store));

export default router;